import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { getOrderData, getOrderSortdata } from "../../seller-apis/apidataField";
import api from "../../seller-apis/api";
import "../../assets/css/payment.css";
import PaymentCard from "../common/PaymentCard";
import { useAlert } from "react-alert";
import moment from 'moment';

var allscrollLen = 0;
var globalFilter = {
  pageNo: 1,
  sortFilter: {
    "createdAt": -1
  },
};
const SellerReturns = () => {
  var outerdiv;
  var loaderDiv;

  const alert = useAlert();

  // Web states
  const [allRecords, setallRecords] = useState();
  const [summaryData, setSummaryData] = useState({});

  // Dates
  const [datefrom, setdatefrom] = useState(moment().subtract(30, 'days').format('YYYY-MM-DD'));
  const [dateto, setdateto] = useState(moment().format('YYYY-MM-DD'));
  const [isDateValid, setisDateValid] = useState(false);
  // Loader
  const [ennewloader, setennewloader] = useState("block");

  // Pagination related
  const [selectedPage, setSelectedPage] = useState(1);
  const [compforPaginationweb, setcompforPaginationweb] = useState("allData");

  // Scroll related events

  const [isallcrollBtnVis, setisallcrollBtnVis] = useState("none");
  const [loadText, setloadText] = useState("Load More");

  // Sorting related states
  const [currstatesort, setcurrstatesort] = useState("State*");
  const [currstatussort, setcurrstatussort] = useState("Status*");

  // Filter related states

  const [orderId, setOrderId] = useState("");
  const [removeFilterClass, setremoveFilterClass] = useState(
    "invent_remove_filter_btn"
  );

  useEffect(() => {
    allscrollLen = 1;
    dateSortFun();
    // let data = {
    //   pageNo: 1,
    // };

    // Summary data

    // api.vendorledger
    //   .getSellerReturns(getOrderData(data))
    //   .then((res) => {
    //     console.log(res);
    //     setSummaryData(res.data);
    //     setallRecords(res.totalRecords);
    //     setennewloader("none");
    //   })
    //   .catch((err) => console.log(err));
  }, []);

  //   Generate excel sheet

  const exportToSheet = () => {
    let btn = document.getElementById("export_Btn");
    btn.innerHTML = `Generating Sheet<span id="dot1"><i class="bi bi-dot"></i></span><span id="dot2"><i class="bi bi-dot"></i></span><span id="dot3"><i class="bi bi-dot"></i></span>`;
    api.vendorledger
      .sellerReturnsExp(getOrderSortdata(globalFilter))
      .then((res) => {
        btn.innerHTML = `Export to Sheet <i class="bi bi-file-earmark-spreadsheet"></i>`;
        const url = window.URL.createObjectURL(res.data);
        var link = document.createElement("a");
        link.href = url;
        link.download =
          datefrom === undefined || datefrom === ""
            ? "Seller-Returns"
            : "Seller-Returns_" + datefrom + "_to_" + dateto;
        link.click();
      })
      .catch((err) => console.log(err));
  };

  // Date sorting

  const dateSortFun = () => {
    if (
      datefrom === "" ||
      datefrom === undefined ||
      dateto === "" ||
      dateto === undefined
    ) {
      alert.info("Please select a date range");
    } else {
      let fromDate = new Date(datefrom);
      let toDate = new Date(dateto);
      let diffDate = toDate.getTime() - fromDate.getTime();
      let daydiffer = 1;
      daydiffer += diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer);
      if (daydiffer > 31) {
        setisDateValid(false);
        alert.info("Date range cannot be more than 1 month.", {
          position: "top center",
        });
        // alert.info("")
      } else if (daydiffer < 0) {
        setisDateValid(false);
        alert.info("Please select a valid date range.");
      } else {
        setisDateValid(true);
        applyLoader();
        globalFilter.pageNo = 1;
        setremoveFilterClass("invent_remove_filter_btn_active");
        globalFilter.filters = {
          ...globalFilter.filters,
          "from-orders-orderPlaceDate": datefrom + "T00:00:00",
          "to-orders-orderPlaceDate": dateto + "T23:59:59",
          "status.label": "Resolved",
          "subStatus.label": "Refund"
        };
        api.vendorledger
          .getSellerReturns(getOrderSortdata(globalFilter))
          .then((res) => {
            allscrollLen = 1;
            setcompforPaginationweb("dateSort");
            setSummaryData(res.data);
            setallRecords(res.totalRecords);
            removeLoader();
          })
          .catch((err) => console.log(err));
      }
    }
  };

  // Clear Filter

  const clearFilter = () => {
    setisDateValid(false);
    setcurrstatesort("State*");
    let fromDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
    let toDate = moment().format('YYYY-MM-DD')
    setdatefrom(fromDate);
    setdateto(toDate);
    setOrderId("");
    setcurrstatussort("Status*");
    setremoveFilterClass("invent_remove_filter_btn");
    globalFilter.pageNo = 1;
    globalFilter.filters = {
      ...globalFilter.filters,
      "from-orders-orderPlaceDate": fromDate + "T00:00:00",
      "to-orders-orderPlaceDate": toDate + "T23:59:59",
      "status.label": "Resolved",
      "subStatus.label": "Refund"
    };
    applyLoader();
    allscrollLen = 1;
    api.vendorledger
      .getSellerReturns(getOrderSortdata(globalFilter))
      .then((res) => {
        console.log(res);
        setSummaryData(res.data);
        setallRecords(res.totalRecords);
        setcompforPaginationweb("allData");
        removeLoader();
      })
      .catch((err) => console.log(err));
  };

  // load more

  function loadMore() {
    if (loadText !== "Loading...") {
      setloadText("Loading...");
      allscrollLen = allscrollLen + 1;
      globalFilter.pageNo = allscrollLen;
      api.vendorledger
        .getSellerReturns(getOrderSortdata(globalFilter))
        .then((res) => {
          setloadText("Load more");
          setSummaryData((summaryData) => summaryData.concat(res.data));
        })
        .catch((err) => console.log(err));
    }
  }

  // Scroll function

  function handleScroll() {
    if (window.scrollY < window.outerHeight) {
      setisallcrollBtnVis("none");
    } else {
      setisallcrollBtnVis("block");
    }
  }

  window.addEventListener("scroll", handleScroll);

  // Sort according to status

  function statussort(e) {
    applyLoader();
    setcurrstatussort(e.value);
    allscrollLen = 1;
    globalFilter.pageNo = allscrollLen;
    globalFilter.filters = {
      ...globalFilter.filters,
      'reverseData.reverse.pkgs.docketStatus': e.value,
    };
    if (e.value === "all") {
      delete globalFilter.filters["reverseData.reverse.pkgs.docketStatus"]
    }
    setremoveFilterClass("invent_remove_filter_btn_active");
    api.vendorledger
      .getSellerReturns(getOrderSortdata(globalFilter))
      .then((res) => {
        setloadText("Load more");
        setSummaryData(res.data);
        setallRecords(res.totalRecords);
        if (res.totalRecords < 1) {
          alert.info("No Records Found");
        }
        setcompforPaginationweb("statussort");
        removeLoader();
      })
      .catch((err) => console.log(err));
  }

  // Sort according to state

  function statesort(e) {
    applyLoader();
    setcurrstatesort(e.value);
    allscrollLen = 1;
    globalFilter.pageNo = allscrollLen;
    setremoveFilterClass("invent_remove_filter_btn_active");
    globalFilter.filters = {
      ...globalFilter.filters,
      "shippingAddress.state": e.value,
    };
    api.vendorledger
      .getSellerReturns(getOrderSortdata(globalFilter))
      .then((res) => {
        setloadText("Load more");
        setSummaryData(res.data);
        setallRecords(res.totalRecords);
        if (res.totalRecords < 1) {
          alert.info("No Records Found");
        }
        setcompforPaginationweb("statesort");
        removeLoader();
      })
      .catch((err) => console.log(err));
  }

  // check event

  function checkevent(e) {
    if (e.keyCode === 13) {
      console.log(globalFilter)
      if (orderId !== "") {
        console.log(globalFilter)
        globalFilter.pageNo = 1;
        allscrollLen = 1;
        if (!globalFilter.orderId) {
          globalFilter.filters = { ...globalFilter.filters, orderId: orderId };
        }
        applyLoader();
        setremoveFilterClass("invent_remove_filter_btn_active");
        api.vendorledger
          .getSellerReturns(getOrderSortdata(globalFilter))
          .then((res) => {
            console.log(res);
            setSummaryData(res.data);
            setallRecords(res.totalRecords);
            if (res.totalRecords < 1) {
              alert.info("No records found");
            }
            removeLoader();
            setcompforPaginationweb("orderId");
          })
          .catch((err) => {
            console.log(err);
            alert.error("Unable to search at this time");
            removeLoader();
            setcompforPaginationweb("orderId");
          });
      } else if (orderId === "") {
        setcompforPaginationweb("allData");
        applyLoader();
        if (globalFilter.filters && globalFilter.filters.orderId) {
          delete globalFilter.filters.orderId;
        }
        globalFilter.pageNo = 1
        setremoveFilterClass("invent_remove_filter_btn");
        allscrollLen = 1;
        api.vendorledger
          .getSellerReturns(getOrderSortdata(globalFilter))
          .then((res) => {
            removeLoader();
            setSummaryData(res.data);
            setallRecords(res.totalRecords);
          })
          .catch((err) => console.log(err));
      }
    }
  }

  // apply loaders

  function applyLoader() {
    outerdiv = document.getElementById("order_summary_Tab");
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex");
    outerdiv.classList.add("div-bk");
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setennewloader("none");
    outerdiv.classList.remove("div-bk");
  }

  return (
    <div id="orDeskContain" className="mb-4">
      {/* New orders desktop */}
      <div className="tab">
        <div className="contain_payment_table mx-2">
          {/* Note container Ticket SL-665 Author - Ankit nigam*/}
          <div className='m-auto mt-1'>
            <span style={{ "color": "red", "font-size": "15px", "font-weigh": "600" }}>NOTE: This report was last updated today morning at 5:00 AM, and does not include the latest updated orders.</span>
          </div>
          <div className="d-flex mb-3 justify-content-between f-d-column">
            {/* Date container */}
            <div className="theme-shed1 p-2">
              <div className="m-auto mt-1">
                <span className="payment_dates">
                  From: -{" "}
                  <input
                    type="date"
                    value={datefrom}
                    onChange={(e) => setdatefrom(e.target.value)}
                  ></input>
                </span>
                <span className="mx-2 payment_dates">
                  To: -{" "}
                  <input
                    type="date"
                    value={dateto}
                    onChange={(e) => setdateto(e.target.value)}
                  ></input>
                </span>

                <span className="double-filter">
                  <span>
                    <button
                      className="apply-btn px-3 py-1 ff_Pop fs-14"
                      onClick={() => dateSortFun()}
                    >
                      Apply
                    </button>
                  </span>
                  <span>
                    <button
                      className={`apply-btn px-3 py-1 ff_Pop fs-14' ${removeFilterClass}`}
                      onClick={() => clearFilter()}
                    >
                      Clear
                    </button>
                  </span>
                </span>
              </div>
            </div>
            {/* <div className='p-2'>
                            <button className='payment_summary_btns mr-2'>Total Orders ({summaryData.totalOrders})</button>
                            <button className='payment_summary_btns mr-2'>Total Transfer price (<i class="fa fa-inr" aria-hidden="true"></i> {summaryData.totalTransferPrice})</button>
                        </div> */}
            {/* Export button */}
            <div className="p-2">
              <button
                className="px-3 py-1 ff_Pop payment_btn_export fs-17"
                id="export_Btn"
                onClick={() => exportToSheet()}
              >
                Export to Sheet <i class="bi bi-file-earmark-spreadsheet"></i>
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table
              className="payment_table"
              style={{ width: "100%" }}
              id="order_summary_Tab"
            >
              <thead>
                <tr className="table_ord_title_row">
                  <th className="thead_title" style={{ width: "5%" }}>
                    Date
                  </th>

                  <th className="thead_title pb-1" style={{ width: "7%" }}>
                    Order Id
                    <br></br>
                    <input
                      type="text"
                      value={orderId}
                      name="name"
                      placeholder="Search"
                      className="w-90 order_table_srch_input"
                      onChange={(e) => setOrderId(e.target.value)}
                      onKeyUp={(e) => checkevent(e, "id")}
                    />
                    <i
                      className="fa fa-search pointer search-space order_table_srch_input_icon"
                      aria-hidden="true"
                      onClick={()=>checkevent({"keyCode":13},"id")}
                    ></i>
                  </th>

                  <th className="thead_title" style={{ width: "7%" }}>
                    Issue reported on
                  </th>

                  <th className="thead_title" style={{ width: "7%" }}>
                    Return status
                    <br></br>
                    <Form.Select
                      size="lg"
                      className="pro_card_comb_box_invent mb-1"
                      style={{ width: "90%" }}
                      onChange={(e) => statussort(e.target)}
                      value={currstatussort}
                    >
                      <option value="Status*" disabled selected>
                        Status*
                      </option>
                      <option value="all">All</option>
                      <option value="Pickup pending">Pickup pending</option>
                      <option value="In transit">In transit</option>
                      <option value="Delivered">Delivered</option>
                    </Form.Select>
                    <br></br>
                  </th>

                  <th className="thead_title" style={{ width: "7%" }}>
                    Invoice no.
                  </th>

                  <th className="thead_title" style={{ width: "7%" }}>
                    Customer Details (with address)
                    <br></br>
                    {/* <Form.Select
                      size="lg"
                      className="pro_card_comb_box_invent mb-1"
                      style={{ width: "90%" }}
                      onChange={(e) => statesort(e.target)}
                      value={currstatesort}
                    >
                      <option value="State*" disabled selected>
                        State*
                      </option>
                      <option value="Andaman and Nicobar Islands">
                        Andaman and Nicobar Islands
                      </option>
                      <option value="Andhra Pradesh"> Andhra Pradesh</option>
                      <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                      <option value="Assam<">Assam</option>
                      <option value="Bihar">Bihar</option>
                      <option value="Chandigarh">Chandigarh</option>
                      <option value="Chhattisgarh">Chhattisgarh</option>
                      <option value="Dadra and Nagar Haveli andDaman and Diu">
                        Dadra and Nagar Haveli and Daman & Diu
                      </option>
                      <option value="Delhi">Delhi</option>
                      <option value="Goa">Goa</option>
                      <option value="Gujarat">Gujarat</option>
                      <option value="Haryana">Haryana</option>
                      <option value="Himachal Pradesh">Himachal Pradesh</option>
                      <option value="JammuKashmir">Jammu & Kashmir</option>
                      <option value="Jharkhand">Jharkhand</option>
                      <option value="Karnataka">Karnataka</option>
                      <option value="Kerela">Kerela</option>
                      <option value="Ladakh">Ladakh</option>
                      <option value="Lakshadweep">Lakshadweep</option>
                      <option value="Madhya Pradesh">Madhya Pradesh</option>
                      <option value="Maharashtra">Maharashtra</option>
                      <option value="Manipur"> Manipur</option>
                      <option value="Meghalaya">Meghalaya</option>
                      <option value="Mizoram">Mizoram</option>
                      <option value="Nagaland">Nagaland</option>
                      <option value="Orissa">Orissa</option>
                      <option value="Punjab">Punjab</option>
                      <option value="Puducherry">Puducherry</option>
                      <option value="Rajasthan">Rajasthan</option>
                      <option value="Sikkim">Sikkim</option>
                      <option value="Tamil Nadu">Tamil Nadu</option>
                      <option value="Telangana">Telangana</option>
                      <option value="Tripura">Tripura</option>
                      <option value="Uttar Pradesh">Uttar Pradesh</option>
                      <option value="Uttarakhand">Uttarakhand</option>
                      <option value="West Bengal">West Bengal</option>
                    </Form.Select> */}
                    <br></br>
                  </th>

                  <th className="thead_title" style={{ width: "15%" }}>
                    Product Details
                  </th>
                  <th className="thead_title" style={{ width: "1%" }}>
                    Quantity
                  </th>

                  <th className="thead_title" style={{ width: "3%" }}>
                    Transfer Price (incl. gst)
                  </th>

                  {/* <th className='thead_title' style={{ "width": "3%" }}>TDS</th>
                                <th className='thead_title' style={{ "width": "3%" }}>Final</th> */}
                </tr>
              </thead>
              <tbody>
                {summaryData.length > 0 ? (
                  summaryData.map((item, index) => {
                    const date = new Date(item.createdAt);
                    const d = date.toUTCString(item.createdAt);
                    const newd = d.substr(4, 12);
                    const ordDetails = item?.orders;
                    const orderPlaceDate = new Date(ordDetails?.orderPlaceDate);
                    const d2 = orderPlaceDate.toUTCString(ordDetails?.orderPlaceDate);
                    const newd2 = d2.substr(4, 12);
                    const userDetails = ordDetails?.userId;
                    const ordProducts = item?.orders?.products?.[0]
                    const productDetails = ordProducts?.productId
                    const customerName = (userDetails?.firstname || "") + " " + (userDetails?.lastName || "")
                    const reverseDocketStatus = item?.reverseData?.reverse?.pkgs?.[0]?.docketStatus
                    const customerDetails = {
                      "gst": item?.orderRecord?.shippingAddress?.landmark,
                      "state": item?.orderRecord?.shippingAddress?.state,
                      "address":item?.orderRecord?.shippingAddress?.address,
                      "customerName": customerName
                    }
                    return (
                      <PaymentCard
                        id={index}
                        lead={item._id}
                        invoice={
                          item.products && item.products[0].tracks.length > 0
                            ? item.products[0].tracks[0].invoice
                            : undefined
                        }
                        date={newd2}
                        issueReportedOn={newd}
                        orderId={item?.orderId}
                        reverseDocketStatus={reverseDocketStatus}
                        invoiceNumber={ordProducts?.inv}
                        gstNo={item.gstNo}
                        productName={productDetails.productName}
                        sku={productDetails?.SKU}
                        quantity={ordProducts?.quantity}
                        sellerPriceExclGst={item?.priceExclGST}
                        gstPercent={productDetails?.taxClass}
                        sellerPriceInclGst={item?.priceInclGST}
                        customerDetails={customerDetails}
                        from="sellerReturns"
                      />
                    );
                  })
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="d-flex justify-content-center" id="enNewLoader">
          <div
            className="spinner-border"
            role="status"
            style={{ display: ennewloader }}
          >
            <span className="sr-only"></span>
          </div>
        </div>

        {allscrollLen * 15 <= allRecords ? (
          <div className="loadMorecntn d-flex justify-content-center ">
            <button
              className="payment_btn_export mt-4"
              onClick={() => loadMore()}
            >
              {loadText}
            </button>
          </div>
        ) : isallcrollBtnVis === "block" ? (
          <>
            <p className="pageendTxt text-center ff_pop mt-4">
              Looks like you have reached bottom of the page
            </p>
          </>
        ) : (
          <></>
        )}

        <div className="scrolltoptnCnt" style={{ display: isallcrollBtnVis }}>
          <a href="#orDeskContain">
            <Button variant="dark">
              <i class="fa fa-arrow-up" aria-hidden="true"></i>
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SellerReturns;
